module.exports = __webpack_public_path__ + "media/images/landing_page/2023/album/album_mobile_en-85ab6160427717a3a3d4ff883cbf3537.png";